<template>
  <auth-layout pageClass="login-page">
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col lg="4" md="6" sm="8">
        <form v-on:submit.prevent="onSubmit">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Forgot Password</h3>
              </div>
              <div>
                <fg-input label="Email"
                          placeholder="Enter email"
                          type="email"
                          autofocus
                          name="email"
                          v-model="model.email"
                          v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'">

                </fg-input>
              </div>
              <div class="text-center">
                <b-button variant="success" type="submit" class="btn-fill btn-round btn-wd "><font-awesome-icon v-if="isLoading" icon="spinner" spin /> Send Reset Link</b-button>
                <br>
                <div class="forgot">
                  <router-link to="/login" class="card-category">
                    Back To Log In
                  </router-link>
                </div>
              </div>
            </card>
          </fade-render-transition>
        </form>
      </b-col>
    </b-row>
  </auth-layout>
</template>
<script>
  import { FadeRenderTransition } from '@/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        errorMsg: null,
        isLoading: false,
        model: {
          email: ''
        }
      }
    },
    methods: {
      onSubmit () {
        if (this.isLoading) {
          return false
        }
        this.$validator.validateAll().then(res => {
          this.$notifications.clear()
          if (res) {
            this.isLoading = true
            this.$http.post(window.AppConfig.apiUrl + 'resetpassword/email', {
              emailAddress: this.model.email,
              account: window.AppConfig.subDomain
            }).then(response => {
              this.isLoading = false
              this.model.email = null
              this.$validator.reset()
              this.$store.dispatch('notification/success', 'Password reset complete, Please check your email inbox or spam.')
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      }
    },
    destroyed () {
      this.$notifications.clear()
    }
  }
</script>

<style scoped>
  button svg {
    float: left;
    margin-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Auth/ForgotPassword.vue